export default __webpack_public_path__ + "static/media/Photo 3 - BR - bonne orientation plan.073cc1cf.png";